export const LANGTYPE_MAPPING = {
  // en: 'english',
  tr: 'turkey',
};

export const APP_LINK = {
  appStore: 'https://itunes.apple.com/app/id1560121894',
  googlePlay: 'https://play.google.com/store/apps/details?id=com.joymi.seven',
  androidAPK: 'https://www.joymi.live/apk/JoyMi-official.apk',
};
